import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsulinPen = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-7 -7 697 697",
	stroke: "currentColor",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m0 0-28.29-28.28L-56.57 0l28.28 28.29",
			transform: "matrix(1.33333 0 0 -1.33333 155.267 565.12)",
			fill: "none",
			strokeWidth: 30,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m0 0-113.14-113.14-56.57 56.57L-56.57 56.57",
			transform: "matrix(1.33333 0 0 -1.33333 324.973 433.12)",
			fill: "none",
			strokeWidth: 30,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "matrix(1.33333 0 0 -1.33333 0 682.667)",
			strokeWidth: 30,
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "m0 0 56.57-56.57",
					transform: "translate(425.43 482)",
					fill: "none",
					strokeWidth: 30,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0 0c-7.81 7.81-7.81 20.48 0 28.29l28.29 28.28c7.81 7.81 20.47 7.81 28.28 0 7.81-7.81 7.81-20.47 0-28.28L28.29 0C20.48-7.81 7.81-7.81 0 0Z",
					transform: "translate(368.86 368.86)",
					fill: "none",
					strokeWidth: 30,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0 0c0-5.523-4.477-10-10-10-5.522 0-10 4.477-10 10s4.478 10 10 10C-4.477 10 0 5.523 0 0",
					transform: "translate(364.226 270.437)",
					stroke: "none"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m0 0 53.013 53.013 42.43 70.71 14.14 14.14c7.81 7.81 7.81 20.48 0 28.29l-28.28 28.28c-7.81 7.81-20.48 7.81-28.29 0l-14.14-14.14-70.71-42.43-167.56-167.56c-7.81-7.81-7.81-20.47 0-28.28l56.57-56.57c7.81-7.81 20.47-7.81 28.28 0l50.946 50.946",
					transform: "translate(386.557 301.707)",
					fill: "none",
					strokeWidth: 30,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		})
	]
});
export default SvgInsulinPen;
